import { useContext, useEffect, useRef, useState } from "react";
import CardHeader from "../../components/generic/cardHeaderDashboard";
import TableDashboard from "../../components/generic/tableDashboard";
import React from "react";
import CardBasic from "../../components/generic/card";
import CardFilter from "../../components/filter/card";
import TitleDashboard from "../../components/generic/dashBoardTitle";
import PieChart from "../../components/charts/pieChart";
import BarChart from "../../components/charts/barChart";
import { Box, Grid, Typography } from "@mui/material";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import BoxTheme from "../../components/generic/box";
import { ThemeContext } from "../../contexts/ThemeContext";
import PrintIcon from "@mui/icons-material/Print";

export default function Dashboard() {
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const [filter, setFilter] = useState({ enterpriseSelected: [] })
  const [visiblePdf, setVisiblePdf] = useState(false);
  const [enterprise, setEnterprise] = useState(null);
  const {menu} = useContext(ThemeContext)
  const { user } = useContext(AuthContext)
  const navigate = useNavigate()
  const dashboardTodo = useRef();
  const handlePdf = useReactToPrint({
    content: () => dashboardTodo.current,
  });

  const permissionDashboard = [];

  user?.permission?.map((el) => {
    if (el.name == "Dashboard") {
      permissionDashboard.push(...el.permission);
    }
  });

  useEffect(() => {
    if (user?.id) {
      if (!permissionDashboard.find((el) => el.name == "Visualizar")) {
        navigate("/notpermission")
      }
    }

    return () => {
      
    }
  }, [user]);
  localStorage.setItem("clientIdPdfEstatistico", JSON.stringify(filter?.enterpriseSelected));

  const data = encodeURIComponent(JSON.stringify(filter?.data))
  const enterpriseEncode = encodeURIComponent(JSON.stringify(enterprise))
  const link = `/previewPdf`
  const refPieChart = useRef()
  const heightBar = !!refPieChart?.current?.offsetHeight ? `${refPieChart?.current?.offsetHeight}px` : "45%"
  
  return (
    <>
      {permissionDashboard.length > 0 ? (
        <>
          <Grid container spacing={2} >
            <Grid item xs={12} >
              <CardFilter filter={filter} hadleFilterParent={dados => setFilter(dados)}></CardFilter>
            </Grid>
            {(user?.id_client == 25886008 || true == true
              ? filter?.enterpriseSelected
              : !!user?.id_client) && filter?.data ? (
              <Grid item xs={12} sx={{ paddingTop: "8px !important" }}>
                <CardHeader
                setEnterpriseSelected={(dados) => setEnterprise(arr => {
                  
                  let arrBer = []
                  if(arr){
                    arrBer = [...arr,...dados] 
                  } else {
                    arrBer = [...dados] 
                  }
                  let array = []
                  arrBer.map((obj)=>{
                    if (filter?.enterpriseSelected.find((obj2)=> obj2 == obj.cre_id) && !array.find((obj3) => obj3.cre_id ==  obj.cre_id)) {
                      array.push(obj)
                      
                    }
                  })
                  return [...array]
                })}
                closeFilter={() => setFilter({ enterpriseSelected: [] })}
                enterpriseSelected={filter?.enterpriseSelected}
                filter={filter}
                >
                  <Grid sx={{display:"flex", justifyContent:"end",marginRight:"60px"}}>
                  <a
                    href={link}
                    style={{
                      color: "white",
                      backgroundColor: "#0032A0",
                      width: "40px",
                      height: "40px",
                      padding: "6px 8px",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    target="_blank" rel="noreferrer"
                    >
                    <PrintIcon  sx={{color:'white'}}/>
                  </a>
                    </Grid>
                </CardHeader>
              </Grid>
            ) : null}
          </Grid>
          {(user?.id_client == 25886008 ? filter?.enterpriseSelected : !!user?.id_client) && filter?.data ? (
            <Box sx={{width: "100%"}}>
              <Grid container sx={{ justifyContent: "space-between",width: "100%" }}  >
                {
                  filter?.data?.report1?.length > 0 ? (
                    <Grid item xs={"auto"} className={menu ? "col-dashboard active" : "col-dashboard"} sx={{padding: "0px !important", }}>
                      <CardBasic sx={{minWidth: "350px", height: "100%", padding: "0", paddingTop: "8px" }}>
                        <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between" }}>
                          <Typography sx={{ color: "#2c4992", fontWeight: 'bold', fontSize: "1rem", textAlign: "center",marginBottom:"5px" }}>
                            Carteira
                          </Typography>
                          <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between", alignItems: "center", gap: "50px" , }}>
                            <BoxTheme sx={{ width: "100%",height: heightBar,display: "flex", justifyContent: "center",maxWidth: "350px"  }}>
                              <BarChart data={filter?.data?.report1}></BarChart>
                            </BoxTheme>
                            <TableDashboard data={filter?.data?.report1} enterpriseSelected={filter?.enterpriseSelected} analytic={filter?.data?.resumo}></TableDashboard>
                          </BoxTheme>
                        </BoxTheme>
                      </CardBasic>
                    </Grid>
                  ) : null
                }
                  {
                    filter?.data?.report3?.length > 0 ? (
                      <Grid item xs={"auto"} className={menu ? "col-dashboard active" : "col-dashboard"} sx={{padding: "0px !important"}}>
                        <CardBasic sx={{minWidth: "350px", height: "100%", padding: "0", paddingTop: "8px" }}>
                          <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between" }}>
                            <Typography sx={{ color: "#2c4992", fontWeight: 'bold', fontSize: "1rem", textAlign: "center",marginBottom:"5px" }}>
                              Resultados
                            </Typography>
                            <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between", alignItems: "center", gap: "50px" }}>
                              <BoxTheme overflow-x='scroll' sx={{ width: "375",height: "375", display: "flex", justifyContent: "center" ,}}>
                                <PieChart  data={filter?.data?.report3}></PieChart>
                              </BoxTheme>
                              <TableDashboard data={filter?.data?.report3} enterpriseSelected={filter?.enterpriseSelected} analytic={filter?.data?.resumo}></TableDashboard>
                            </BoxTheme>
                          </BoxTheme>
                        </CardBasic>
                      </Grid>
                    ) : null
                  }
                {
                  filter?.data?.report2?.length > 0 ? (
                    <Grid item xs={"auto"} className={menu ? "col-dashboard active" : "col-dashboard"} sx={{padding: "0px !important"}}>
                      <CardBasic sx={{minWidth: "350px", height: "100%", padding: "0", paddingTop: "8px" }}>
                        <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between"}}>
                          <Typography sx={{ color: "#2c4992", fontWeight: 'bold', fontSize: "1rem", textAlign: "center",marginBottom:"5x" }}>
                            Finalizados
                          </Typography>
                          <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between", alignItems: "center", gap: "50px"}}>
                            <Box overflow-x='scroll' sx={{ width: "375",height: "375", display: "flex", justifyContent: "center"}} ref={refPieChart}>
                              <PieChart data={filter?.data?.report2}></PieChart>
                            </Box>
                            <TableDashboard  data={filter?.data?.report2} enterpriseSelected={filter?.enterpriseSelected} analytic={filter?.data?.resumo}></TableDashboard>
                          </BoxTheme>
                        </BoxTheme>
                      </CardBasic>
                    </Grid>
                  ) : null
                }
              </Grid>
            </Box>
          ) : null}
        </>
      ) : null}
    </>
  );
}
